// getters
const schoolroutesVehicles = state => state.schoolroutesVehicles

export default {
  schoolroutesVehicles
}



// WEBPACK FOOTER //
// ./src/store/modules/schoolroutes/vehicles/getters.js